/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import util from "./util.js";

/*
Custom validation setup that provides a 'brief' error message for displaying under
the relevant field, and a 'full' error message for showing in the review & submit tab.
 */
function validate(observable, validator, data) {
	var initialValue = observable();

	observable.showError = ko.observable(false);

	observable.validateInfo = data || {};

	observable.errorInfo = ko.pureComputed(function() {
		if(observable() != initialValue) {
			observable.showError(true);
		}
		return validator(observable());
	});

	observable.error = ko.pureComputed(function() {
		var error = observable.errorInfo();

		if(!observable.showError()) {
			return;
		}

		if(error && error.brief) {
			return error.brief;
		} else {
			return error || null;
		}
	});

	observable.fullError = ko.pureComputed(function() {
		var error = observable.errorInfo();
		if(error && error.full) {
			return error.full;
		} else {
			return error || null;
		}
	});

	observable.valid = ko.pureComputed(function() {
		return !observable.error();
	});

	return observable;
}


// --- Validators - fluent API
// e.g. validate.field(gardenSize, "Garden size", {tab: "biby_site_condition"}).required().isInt().build();

var availableValidators = {
	required: function(val, label) {
		if(!val && val !== false) {
			return {
				full: label + " must be specified",
				brief: "This field is required"
			};
		}
	},
	isInt: function(val, label) {
		if(!util.isInt(val)) {
			return {
				full: label + " must be a whole number",
				brief: "Must be a whole number"
			};
		}
	}
};

// DEPRECATED: this is only used in a handful of places
function Builder(observable, label, data) {
	this.validators = [];
	this.observable = observable;
	this.label = label;
	this.data = data;
}

Object.entries(availableValidators).forEach(function([key, validator]) {
	Builder.prototype[key] = function() {
		var args = [].slice.apply(arguments);

		this.validators.push(function(val, label) {
			return validator.apply(self, [val, label, ...args]);
		});
		return this;
	};
});

Builder.prototype.onlyIf = function(conditionFn) {
	this.conditionFn = conditionFn;
	return this;
};

Builder.prototype.validate = function(val) {
	var label = this.label;
	if(!this.conditionFn || this.conditionFn(val)) {
		return this.validators.reduce(function(error, validator) {
			return error || validator(val, label);
		}, null);
	}
};

Builder.prototype.build = function() {
	return validate(this.observable, this.validate.bind(this), this.data);
};

validate.field = function(o,l,d) {
	return new Builder(o,l,d);
};

export default validate;
